import React, { useEffect, useContext } from 'react'
import {
  Button,
  Col,
  Row,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
} from 'reactstrap'
import ProductContext from 'context/product/productContext'
import ReactTable from 'react-table'
import {
  getReviewedProductComponents,
  reviewedColumnHeaders,
  psScrollToTop,
} from './Utilities'

import ProductInfo from './ProductInfo'

const BSProductsReviewed = () => {
  const { getReviewedBSProducts, products, exportData } = useContext(
    ProductContext
  )

  useEffect(() => {
    psScrollToTop()
    console.log('BSProductsReviewed: ...loading')
    getReviewedBSProducts()
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    psScrollToTop()
  }, [products])

  const getProductInfo = product => {
    const components = getReviewedProductComponents(product)
    return <ProductInfo {...components} product={product} />
  }

  return (
    <div className="content">
      <Row>
        <Col>
          <Card>
            <CardHeader>
              <CardTitle className="float-left" tag="h4">
                Brand Specific Products Reviewed
              </CardTitle>
              {products?.length > 0 && (
                <>
                  <Button
                    className="btn-round float-right"
                    color="info"
                    onClick={() => exportData('Authorized Products', true)}
                  >
                    <i className="nc-icon nc-cloud-download-93" /> Export
                    Authorized Products
                  </Button>
                  <Button
                    className="btn-round float-right"
                    color="info"
                    onClick={() => exportData('All Reviewed Products', false)}
                  >
                    <i className="nc-icon nc-cloud-download-93" /> Export All
                    Reviewed Products
                  </Button>
                </>
              )}
            </CardHeader>
            <CardBody>
              <ReactTable
                data={products ?? []}
                filterable
                columns={reviewedColumnHeaders}
                defaultPageSize={10}
                showPaginationTop
                showPaginationBottom={false}
                className="-striped -highlight primary-pagination"
                SubComponent={({ original }) => getProductInfo(original)}
              />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  )
}

export default BSProductsReviewed
